import React, { useState } from 'react';
import { InputLabel, OutlinedInput, Tooltip, Typography, Select, MenuItem, Button } from '@mui/material';
import "../../styles/UserDashboard/Kyc.scss";


const KYCGovernanceMonitoringForm = ({ onComplete, userId, token }) => {
  const [facilityInfo, setFacilityInfo] = useState({
    facilityName: '',
    facilityDescription: '',
    facilityLocation: '',
    projectStartDate: '',
    projectEndDate: '',
    generatorFuelType: '',
    generatorFuelTypeOther: '',
    usesGridElectricity: null,
  });
  const [usesGridElectricity, setUsesGridElectricity] = useState(null);
  const [showDropdownGenerator, setShowDropdownGenerator] = useState(false);
  const [loading, setLoading] = useState(false);


  const handleFacilityChange = (field, value) => {
    setFacilityInfo(prev => ({ ...prev, [field]: value }));
  };

  // const validateFacilityForm = () => {
  //   const requiredFields = ['facilityName', 'facilityDescription', 'facilityLocation', 'projectStartDate', 'projectEndDate', 'generatorFuelType'];
  //   return requiredFields.every(field => {
  //     if (Array.isArray(facilityInfo[field])) {
  //       return facilityInfo[field].length > 0;
  //     }
  //     return facilityInfo[field] && typeof facilityInfo[field] === 'string' && facilityInfo[field].trim() !== '';
  //   });
  // };
  const validateFacilityForm = () => {
    const requiredFields = ['facilityName', 'facilityDescription', 'facilityLocation', 'projectStartDate', 'projectEndDate', 'generatorFuelType'];

    const basicValidation = requiredFields.every(field => {
      if (Array.isArray(facilityInfo[field])) {
        return facilityInfo[field].length > 0;
      }
      return facilityInfo[field] && typeof facilityInfo[field] === 'string' && facilityInfo[field].trim() !== '';
    });

    // Additional validation for "others" fuel type
    if (facilityInfo.generatorFuelType === 'others' && (!facilityInfo.generatorFuelTypeOther || facilityInfo.generatorFuelTypeOther.trim() === '')) {
      alert('Please specify the generator fuel type when selecting "Others"');
      return false;
    }

    return basicValidation;
  };

  const handleFacilityComplete = async (e) => {
    e.preventDefault();

    // Validate form fields first
    if (!validateFacilityForm()) {
      alert('Please fill in all required fields before continuing.');
      return;
    }

    // Validate project dates
    if (Date.now() > Date.parse(facilityInfo.projectEndDate)) {
      alert("Project end date can not be in the past");
      return;
    }

    if (Date.parse(facilityInfo.projectStartDate) > Date.parse(facilityInfo.projectEndDate)) {
      alert("Project start date can not be ahead of Project end date ");
      return;
    }
    const completeData = {
      ...facilityInfo,
    };
    if (onComplete) onComplete(completeData);
    setLoading(false);
  };

  const facilityStepComplete = validateFacilityForm();

  return (
    <div className="kyc_modal_container">
      <div className="kyc_modal">
        <div className="title" style={{ textAlign: 'start', flex: 1 }}>Step into the future...</div>

        <div className="subtitle" style={{ textAlign: 'start' }}>
          Complete this KYC step, your safety our priority
        </div>

        <form className="kyc_grid" onSubmit={handleFacilityComplete}>
          <div className="kyc_grid">
            <div>
              <InputLabel
                className="kyc_label"
                htmlFor="organizationDescription"
              >
                Facility name
                <Tooltip
                  title={
                    <Typography variant="h6">
                      Enter facility name
                    </Typography>
                  }
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="-0.5 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      {" "}
                      <path
                        d="M12 21.5C17.1086 21.5 21.25 17.3586 21.25 12.25C21.25 7.14137 17.1086 3 12 3C6.89137 3 2.75 7.14137 2.75 12.25C2.75 17.3586 6.89137 21.5 12 21.5Z"
                        stroke="#667185"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>{" "}
                      <path
                        d="M12.9309 8.15005C12.9256 8.39231 12.825 8.62272 12.6509 8.79123C12.4767 8.95974 12.2431 9.05271 12.0008 9.05002C11.8242 9.04413 11.6533 8.98641 11.5093 8.884C11.3652 8.7816 11.2546 8.63903 11.1911 8.47415C11.1275 8.30927 11.1139 8.12932 11.152 7.95675C11.19 7.78419 11.278 7.6267 11.405 7.50381C11.532 7.38093 11.6923 7.29814 11.866 7.26578C12.0397 7.23341 12.2192 7.25289 12.3819 7.32181C12.5446 7.39072 12.6834 7.506 12.781 7.65329C12.8787 7.80057 12.9308 7.97335 12.9309 8.15005ZM11.2909 16.5301V11.1501C11.2882 11.0556 11.3046 10.9615 11.3392 10.8736C11.3738 10.7857 11.4258 10.7057 11.4922 10.6385C11.5585 10.5712 11.6378 10.518 11.7252 10.4822C11.8126 10.4464 11.9064 10.4286 12.0008 10.43C12.094 10.4299 12.1863 10.4487 12.272 10.4853C12.3577 10.5218 12.4352 10.5753 12.4997 10.6426C12.5642 10.7099 12.6143 10.7895 12.6472 10.8767C12.6801 10.9639 12.6949 11.0569 12.6908 11.1501V16.5301C12.6908 16.622 12.6727 16.713 12.6376 16.7979C12.6024 16.8828 12.5508 16.96 12.4858 17.025C12.4208 17.09 12.3437 17.1415 12.2588 17.1767C12.1738 17.2119 12.0828 17.23 11.9909 17.23C11.899 17.23 11.8079 17.2119 11.723 17.1767C11.6381 17.1415 11.5609 17.09 11.4959 17.025C11.4309 16.96 11.3793 16.8828 11.3442 16.7979C11.309 16.713 11.2909 16.622 11.2909 16.5301Z"
                        fill="#667185"
                      ></path>{" "}
                    </g>
                  </svg>
                </Tooltip>
              </InputLabel>

              <OutlinedInput
                className="kyc_input"
                required
                id="organizationDescription"
                type="text"
                placeholder="Enter facility/project name"
                name="organizationDescription"
                value={facilityInfo.facilityName}
                onChange={(e) => handleFacilityChange('facilityName', e.target.value)}
              />
            </div>
            <div>
              <InputLabel
                className="kyc_label"
                htmlFor="organizationDescription"
              >
                Facility description
                <Tooltip
                  title={
                    <Typography variant="h6">
                      A brief explanation of what your facility does
                    </Typography>
                  }
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="-0.5 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      {" "}
                      <path
                        d="M12 21.5C17.1086 21.5 21.25 17.3586 21.25 12.25C21.25 7.14137 17.1086 3 12 3C6.89137 3 2.75 7.14137 2.75 12.25C2.75 17.3586 6.89137 21.5 12 21.5Z"
                        stroke="#667185"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>{" "}
                      <path
                        d="M12.9309 8.15005C12.9256 8.39231 12.825 8.62272 12.6509 8.79123C12.4767 8.95974 12.2431 9.05271 12.0008 9.05002C11.8242 9.04413 11.6533 8.98641 11.5093 8.884C11.3652 8.7816 11.2546 8.63903 11.1911 8.47415C11.1275 8.30927 11.1139 8.12932 11.152 7.95675C11.19 7.78419 11.278 7.6267 11.405 7.50381C11.532 7.38093 11.6923 7.29814 11.866 7.26578C12.0397 7.23341 12.2192 7.25289 12.3819 7.32181C12.5446 7.39072 12.6834 7.506 12.781 7.65329C12.8787 7.80057 12.9308 7.97335 12.9309 8.15005ZM11.2909 16.5301V11.1501C11.2882 11.0556 11.3046 10.9615 11.3392 10.8736C11.3738 10.7857 11.4258 10.7057 11.4922 10.6385C11.5585 10.5712 11.6378 10.518 11.7252 10.4822C11.8126 10.4464 11.9064 10.4286 12.0008 10.43C12.094 10.4299 12.1863 10.4487 12.272 10.4853C12.3577 10.5218 12.4352 10.5753 12.4997 10.6426C12.5642 10.7099 12.6143 10.7895 12.6472 10.8767C12.6801 10.9639 12.6949 11.0569 12.6908 11.1501V16.5301C12.6908 16.622 12.6727 16.713 12.6376 16.7979C12.6024 16.8828 12.5508 16.96 12.4858 17.025C12.4208 17.09 12.3437 17.1415 12.2588 17.1767C12.1738 17.2119 12.0828 17.23 11.9909 17.23C11.899 17.23 11.8079 17.2119 11.723 17.1767C11.6381 17.1415 11.5609 17.09 11.4959 17.025C11.4309 16.96 11.3793 16.8828 11.3442 16.7979C11.309 16.713 11.2909 16.622 11.2909 16.5301Z"
                        fill="#667185"
                      ></path>{" "}
                    </g>
                  </svg>
                </Tooltip>
              </InputLabel>

              <OutlinedInput
                className="kyc_input"
                required
                id="organizationDescription"
                type="text"
                placeholder="Provide a summary description of the facility to enable an understanding of the nature and its implementation."
                name="organizationDescription"
                value={facilityInfo.facilityDescription}
                onChange={(e) => handleFacilityChange('facilityDescription', e.target.value)}
              />
              <div className="kyc_instructions">
                <div className=" mt-4 kyc_instructions__title">
                  Include the following:
                </div>
                <div className="kyc_instructions__subtitle">
                  <svg
                    width="4"
                    height="4"
                    viewBox="0 0 4 4"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="2" cy="2" r="2" fill="#D9D9D9" />
                  </svg>
                  The objectives of the project
                </div>
                <div className="kyc_instructions__subtitle">
                  <svg
                    width="4"
                    height="4"
                    viewBox="0 0 4 4"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="2" cy="2" r="2" fill="#D9D9D9" />
                  </svg>
                  Describe the project activity or activities
                </div>
                <div className="kyc_instructions__subtitle">
                  <svg
                    width="4"
                    height="4"
                    viewBox="0 0 4 4"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="2" cy="2" r="2" fill="#D9D9D9" />
                  </svg>
                  An estimate of annual average, total reductions and removals
                </div>
              </div>
            </div>
            <div>
              <InputLabel className="kyc_label" htmlFor="location">
                Facility location
                <Tooltip
                  title={
                    <Typography variant="h6">
                      Enter facility address
                    </Typography>
                  }
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="-0.5 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      {" "}
                      <path
                        d="M12 21.5C17.1086 21.5 21.25 17.3586 21.25 12.25C21.25 7.14137 17.1086 3 12 3C6.89137 3 2.75 7.14137 2.75 12.25C2.75 17.3586 6.89137 21.5 12 21.5Z"
                        stroke="#667185"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>{" "}
                      <path
                        d="M12.9309 8.15005C12.9256 8.39231 12.825 8.62272 12.6509 8.79123C12.4767 8.95974 12.2431 9.05271 12.0008 9.05002C11.8242 9.04413 11.6533 8.98641 11.5093 8.884C11.3652 8.7816 11.2546 8.63903 11.1911 8.47415C11.1275 8.30927 11.1139 8.12932 11.152 7.95675C11.19 7.78419 11.278 7.6267 11.405 7.50381C11.532 7.38093 11.6923 7.29814 11.866 7.26578C12.0397 7.23341 12.2192 7.25289 12.3819 7.32181C12.5446 7.39072 12.6834 7.506 12.781 7.65329C12.8787 7.80057 12.9308 7.97335 12.9309 8.15005ZM11.2909 16.5301V11.1501C11.2882 11.0556 11.3046 10.9615 11.3392 10.8736C11.3738 10.7857 11.4258 10.7057 11.4922 10.6385C11.5585 10.5712 11.6378 10.518 11.7252 10.4822C11.8126 10.4464 11.9064 10.4286 12.0008 10.43C12.094 10.4299 12.1863 10.4487 12.272 10.4853C12.3577 10.5218 12.4352 10.5753 12.4997 10.6426C12.5642 10.7099 12.6143 10.7895 12.6472 10.8767C12.6801 10.9639 12.6949 11.0569 12.6908 11.1501V16.5301C12.6908 16.622 12.6727 16.713 12.6376 16.7979C12.6024 16.8828 12.5508 16.96 12.4858 17.025C12.4208 17.09 12.3437 17.1415 12.2588 17.1767C12.1738 17.2119 12.0828 17.23 11.9909 17.23C11.899 17.23 11.8079 17.2119 11.723 17.1767C11.6381 17.1415 11.5609 17.09 11.4959 17.025C11.4309 16.96 11.3793 16.8828 11.3442 16.7979C11.309 16.713 11.2909 16.622 11.2909 16.5301Z"
                        fill="#667185"
                      ></path>{" "}
                    </g>
                  </svg>
                </Tooltip>
              </InputLabel>

              <OutlinedInput
                className="kyc_input"
                required
                id="location"
                type="text"
                placeholder="Enter facility/project address"
                name="location"
                value={facilityInfo.facilityLocation}
                onChange={(e) => handleFacilityChange('facilityLocation', e.target.value)}
              />
            </div>
            <div className="kyc_group">
              <div>
                <InputLabel className="kyc_label" htmlFor="location">
                  Facility start date

                  <Tooltip
                    title={
                      <Typography variant="h6">
                        Enter  facility/project start
                      </Typography>
                    }
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="-0.5 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M12 21.5C17.1086 21.5 21.25 17.3586 21.25 12.25C21.25 7.14137 17.1086 3 12 3C6.89137 3 2.75 7.14137 2.75 12.25C2.75 17.3586 6.89137 21.5 12 21.5Z"
                          stroke="#667185"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M12.9309 8.15005C12.9256 8.39231 12.825 8.62272 12.6509 8.79123C12.4767 8.95974 12.2431 9.05271 12.0008 9.05002C11.8242 9.04413 11.6533 8.98641 11.5093 8.884C11.3652 8.7816 11.2546 8.63903 11.1911 8.47415C11.1275 8.30927 11.1139 8.12932 11.152 7.95675C11.19 7.78419 11.278 7.6267 11.405 7.50381C11.532 7.38093 11.6923 7.29814 11.866 7.26578C12.0397 7.23341 12.2192 7.25289 12.3819 7.32181C12.5446 7.39072 12.6834 7.506 12.781 7.65329C12.8787 7.80057 12.9308 7.97335 12.9309 8.15005ZM11.2909 16.5301V11.1501C11.2882 11.0556 11.3046 10.9615 11.3392 10.8736C11.3738 10.7857 11.4258 10.7057 11.4922 10.6385C11.5585 10.5712 11.6378 10.518 11.7252 10.4822C11.8126 10.4464 11.9064 10.4286 12.0008 10.43C12.094 10.4299 12.1863 10.4487 12.272 10.4853C12.3577 10.5218 12.4352 10.5753 12.4997 10.6426C12.5642 10.7099 12.6143 10.7895 12.6472 10.8767C12.6801 10.9639 12.6949 11.0569 12.6908 11.1501V16.5301C12.6908 16.622 12.6727 16.713 12.6376 16.7979C12.6024 16.8828 12.5508 16.96 12.4858 17.025C12.4208 17.09 12.3437 17.1415 12.2588 17.1767C12.1738 17.2119 12.0828 17.23 11.9909 17.23C11.899 17.23 11.8079 17.2119 11.723 17.1767C11.6381 17.1415 11.5609 17.09 11.4959 17.025C11.4309 16.96 11.3793 16.8828 11.3442 16.7979C11.309 16.713 11.2909 16.622 11.2909 16.5301Z"
                          fill="#667185"
                        ></path>{" "}
                      </g>
                    </svg>
                  </Tooltip>
                </InputLabel>

                <input
                  className="kyc_input kyc_input-date"
                  required
                  id="location"
                  type="date"
                  placeholder="Enter facility/project start date"
                  name="location"
                  value={facilityInfo.projectStartDate}
                  onChange={(e) => handleFacilityChange('projectStartDate', e.target.value)}
                />
              </div>
              <div>
                <InputLabel className="kyc_label" htmlFor="location">
                  Facility end date

                  <Tooltip
                    title={
                      <Typography variant="h6">
                        Enter facility/project end date
                      </Typography>
                    }
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="-0.5 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M12 21.5C17.1086 21.5 21.25 17.3586 21.25 12.25C21.25 7.14137 17.1086 3 12 3C6.89137 3 2.75 7.14137 2.75 12.25C2.75 17.3586 6.89137 21.5 12 21.5Z"
                          stroke="#667185"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M12.9309 8.15005C12.9256 8.39231 12.825 8.62272 12.6509 8.79123C12.4767 8.95974 12.2431 9.05271 12.0008 9.05002C11.8242 9.04413 11.6533 8.98641 11.5093 8.884C11.3652 8.7816 11.2546 8.63903 11.1911 8.47415C11.1275 8.30927 11.1139 8.12932 11.152 7.95675C11.19 7.78419 11.278 7.6267 11.405 7.50381C11.532 7.38093 11.6923 7.29814 11.866 7.26578C12.0397 7.23341 12.2192 7.25289 12.3819 7.32181C12.5446 7.39072 12.6834 7.506 12.781 7.65329C12.8787 7.80057 12.9308 7.97335 12.9309 8.15005ZM11.2909 16.5301V11.1501C11.2882 11.0556 11.3046 10.9615 11.3392 10.8736C11.3738 10.7857 11.4258 10.7057 11.4922 10.6385C11.5585 10.5712 11.6378 10.518 11.7252 10.4822C11.8126 10.4464 11.9064 10.4286 12.0008 10.43C12.094 10.4299 12.1863 10.4487 12.272 10.4853C12.3577 10.5218 12.4352 10.5753 12.4997 10.6426C12.5642 10.7099 12.6143 10.7895 12.6472 10.8767C12.6801 10.9639 12.6949 11.0569 12.6908 11.1501V16.5301C12.6908 16.622 12.6727 16.713 12.6376 16.7979C12.6024 16.8828 12.5508 16.96 12.4858 17.025C12.4208 17.09 12.3437 17.1415 12.2588 17.1767C12.1738 17.2119 12.0828 17.23 11.9909 17.23C11.899 17.23 11.8079 17.2119 11.723 17.1767C11.6381 17.1415 11.5609 17.09 11.4959 17.025C11.4309 16.96 11.3793 16.8828 11.3442 16.7979C11.309 16.713 11.2909 16.622 11.2909 16.5301Z"
                          fill="#667185"
                        ></path>{" "}
                      </g>
                    </svg>
                  </Tooltip>
                </InputLabel>

                <input
                  className="kyc_input kyc_input-date"
                  id="location"
                  type="date"
                  placeholder="Enter facility/project end date"
                  name="location"
                  value={facilityInfo.projectEndDate}
                  onChange={(e) => handleFacilityChange('projectEndDate', e.target.value)}
                />
              </div>
            </div>

            <div>
              <InputLabel
                className="kyc_label"
                htmlFor="quantifiedBasedYearEmission"
              >
                Generator fuel type

                <Tooltip
                  title={
                    <Typography variant="h6">
                      Select fuel type used in facility
                    </Typography>
                  }
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="-0.5 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      {" "}
                      <path
                        d="M12 21.5C17.1086 21.5 21.25 17.3586 21.25 12.25C21.25 7.14137 17.1086 3 12 3C6.89137 3 2.75 7.14137 2.75 12.25C2.75 17.3586 6.89137 21.5 12 21.5Z"
                        stroke="#667185"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>{" "}
                      <path
                        d="M12.9309 8.15005C12.9256 8.39231 12.825 8.62272 12.6509 8.79123C12.4767 8.95974 12.2431 9.05271 12.0008 9.05002C11.8242 9.04413 11.6533 8.98641 11.5093 8.884C11.3652 8.7816 11.2546 8.63903 11.1911 8.47415C11.1275 8.30927 11.1139 8.12932 11.152 7.95675C11.19 7.78419 11.278 7.6267 11.405 7.50381C11.532 7.38093 11.6923 7.29814 11.866 7.26578C12.0397 7.23341 12.2192 7.25289 12.3819 7.32181C12.5446 7.39072 12.6834 7.506 12.781 7.65329C12.8787 7.80057 12.9308 7.97335 12.9309 8.15005ZM11.2909 16.5301V11.1501C11.2882 11.0556 11.3046 10.9615 11.3392 10.8736C11.3738 10.7857 11.4258 10.7057 11.4922 10.6385C11.5585 10.5712 11.6378 10.518 11.7252 10.4822C11.8126 10.4464 11.9064 10.4286 12.0008 10.43C12.094 10.4299 12.1863 10.4487 12.272 10.4853C12.3577 10.5218 12.4352 10.5753 12.4997 10.6426C12.5642 10.7099 12.6143 10.7895 12.6472 10.8767C12.6801 10.9639 12.6949 11.0569 12.6908 11.1501V16.5301C12.6908 16.622 12.6727 16.713 12.6376 16.7979C12.6024 16.8828 12.5508 16.96 12.4858 17.025C12.4208 17.09 12.3437 17.1415 12.2588 17.1767C12.1738 17.2119 12.0828 17.23 11.9909 17.23C11.899 17.23 11.8079 17.2119 11.723 17.1767C11.6381 17.1415 11.5609 17.09 11.4959 17.025C11.4309 16.96 11.3793 16.8828 11.3442 16.7979C11.309 16.713 11.2909 16.622 11.2909 16.5301Z"
                        fill="#667185"
                      ></path>{" "}
                    </g>
                  </svg>
                </Tooltip>
              </InputLabel>
              <div className="kyc_dropdown_checkbox_container">
                <div className="kyc_dropdown" style={{ position: 'relative' }}>
                  <div
                    className="kyc_input kyc_dropdown_input"
                    style={{ cursor: 'pointer', minHeight: 40, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                    onClick={() => setShowDropdownGenerator(prev => !prev)}
                  >
                    <span>
                      {facilityInfo.generatorFuelType
                        ? facilityInfo.generatorFuelType === 'others' && facilityInfo.generatorFuelTypeOther && facilityInfo.generatorFuelTypeOther.trim() !== ''
                          ? facilityInfo.generatorFuelTypeOther
                          : facilityInfo.generatorFuelType
                        : 'Select generator fuel type'}
                    </span>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ marginRight: 24, transition: 'transform 0.2s', transform: showDropdownGenerator ? 'rotate(180deg)' : 'rotate(0deg)' }}
                    >
                      <path d="M6 8L10 12L14 8" stroke="#667085" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  {showDropdownGenerator && (
                    <div className="kyc_dropdown_menu" style={{ position: 'absolute', zIndex: 10, background: '#fff', border: '1px solid #ccc', borderRadius: 8, width: '100%', marginTop: 4, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
                      {[
                        { label: 'Coal', value: 'Coal' },
                        { label: 'Diesel', value: 'Diesel' },
                        { label: 'Natural gas', value: 'Natural gas' },
                        { label: 'Petroleum', value: 'Petroleum' },
                        { label: 'LPG', value: 'LPG' },
                        { label: 'Propane', value: 'Propane' },
                        { label: 'Kerosene', value: 'kerosene' },
                        { label: 'Shale oil', value: 'Shale' },
                        { label: 'Not Applicable', value: 'notApplicablem' },
                        { label: 'Others (please Specify)', value: 'others' },
                      ].map(option => (
                        <div key={option.value} style={{ display: 'flex', alignItems: 'center', padding: '6px 12px' }}>
                          {facilityInfo.generatorFuelType === option.value ? (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              onClick={() => {
                                // Deselect current option
                                handleFacilityChange('generatorFuelType', '');
                                if (option.value === 'others') handleFacilityChange('generatorFuelTypeOther', '');
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                              <rect
                                x="1"
                                y="1"
                                width="16"
                                height="16"
                                rx="4"
                                stroke="url(#paint0_linear_2889_18037)"
                                strokeWidth="1.33333"
                              />
                              <path
                                d="M5.5 9.49992L7.83333 11.8333L12.5 6.83325"
                                stroke="url(#paint1_linear_2889_18037)"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <defs>
                                <linearGradient
                                  id="paint0_linear_2889_18037"
                                  x1="1"
                                  y1="1.36719"
                                  x2="20.0689"
                                  y2="10.7886"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stopColor="#006633" />
                                  <stop offset="1" stopColor="#02A4CC" />
                                </linearGradient>
                                <linearGradient
                                  id="paint1_linear_2889_18037"
                                  x1="5.5"
                                  y1="6.948"
                                  x2="12.5203"
                                  y2="11.8039"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stopColor="#006633" />
                                  <stop offset="1" stopColor="#02A4CC" />
                                </linearGradient>
                              </defs>
                            </svg>
                          ) : (
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              onClick={() => {
                                // Select this option and clear previous selection
                                handleFacilityChange('generatorFuelType', option.value);
                                // Clear the "others" text field if switching away from "others"
                                if (option.value !== 'others') handleFacilityChange('generatorFuelTypeOther', '');
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                              <rect
                                x="1"
                                y="1"
                                width="16"
                                height="16"
                                rx="4"
                                stroke="url(#paint0_linear_2889_18043)"
                                strokeWidth="1.33333"
                              />
                              <defs>
                                <linearGradient
                                  id="paint0_linear_2889_18043"
                                  x1="1"
                                  y1="1.36719"
                                  x2="20.0689"
                                  y2="10.7886"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stopColor="#006633" />
                                  <stop offset="1" stopColor="#02A4CC" />
                                </linearGradient>
                              </defs>
                            </svg>
                          )}
                          <span style={{ marginLeft: 8, fontSize: 12 }}>{option.label}</span>
                          {option.value === 'others' && facilityInfo.generatorFuelType === 'others' && (
                            <OutlinedInput
                              className="kyc_input"
                              style={{ marginLeft: 12, width: 180, height: 32 }}
                              placeholder="Please specify"
                              value={facilityInfo.generatorFuelTypeOther || ''}
                              onChange={e => handleFacilityChange('generatorFuelTypeOther', e.target.value)}
                            />
                          )}
                        </div>
                      ))}
                      <div style={{ textAlign: 'right', padding: '8px 12px' }}>
                        <Button size="small" variant="outlined" onClick={() => setShowDropdownGenerator(false)}>Done</Button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="kyc-checkbox-grid" style={{ marginTop: 0, marginBottom: 0 }}>
              <div className="kyc-checkbox-grid__title" style={{ marginTop: 0, marginBottom: 0 }}>
                <InputLabel
                  htmlFor="quantifiedBasedYearEmission"
                  style={{
                    fontSize: '14px',
                    fontWeight: 400,
                    color: '#101828',
                  }}
                >
                  Does your facility use grid electricity
                  <Tooltip
                    title={
                      <Typography variant="h6">
                        Does your facility use grid electricity
                      </Typography>
                    }
                  >
                    <svg
                      style={{ verticalAlign: 'middle', display: 'inline-block', marginLeft: 4 }}
                      width="18"
                      height="18"
                      viewBox="-0.5 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        <path
                          d="M12 21.5C17.1086 21.5 21.25 17.3586 21.25 12.25C21.25 7.14137 17.1086 3 12 3C6.89137 3 2.75 7.14137 2.75 12.25C2.75 17.3586 6.89137 21.5 12 21.5Z"
                          stroke="#667185"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M12.9309 8.15005C12.9256 8.39231 12.825 8.62272 12.6509 8.79123C12.4767 8.95974 12.2431 9.05271 12.0008 9.05002C11.8242 9.04413 11.6533 8.98641 11.5093 8.884C11.3652 8.7816 11.2546 8.63903 11.1911 8.47415C11.1275 8.30927 11.1139 8.12932 11.152 7.95675C11.19 7.78419 11.278 7.6267 11.405 7.50381C11.532 7.38093 11.6923 7.29814 11.866 7.26578C12.0397 7.23341 12.2192 7.25289 12.3819 7.32181C12.5446 7.39072 12.6834 7.506 12.781 7.65329C12.8787 7.80057 12.9308 7.97335 12.9309 8.15005ZM11.2909 16.5301V11.1501C11.2882 11.0556 11.3046 10.9615 11.3392 10.8736C11.3738 10.7857 11.4258 10.7057 11.4922 10.6385C11.5585 10.5712 11.6378 10.518 11.7252 10.4822C11.8126 10.4464 11.9064 10.4286 12.0008 10.43C12.094 10.4299 12.1863 10.4487 12.272 10.4853C12.3577 10.5218 12.4352 10.5753 12.4997 10.6426C12.5642 10.7099 12.6143 10.7895 12.6472 10.8767C12.6801 10.9639 12.6949 11.0569 12.6908 11.1501V16.5301C12.6908 16.622 12.6727 16.713 12.6376 16.7979C12.6024 16.8828 12.5508 16.96 12.4858 17.025C12.4208 17.09 12.3437 17.1415 12.2588 17.1767C12.1738 17.2119 12.0828 17.23 11.9909 17.23C11.899 17.23 11.8079 17.2119 11.723 17.1767C11.6381 17.1415 11.5609 17.09 11.4959 17.025C11.4309 16.96 11.3793 16.8828 11.3442 16.7979C11.309 16.713 11.2909 16.622 11.2909 16.5301Z"
                          fill="#667185"
                        ></path>
                      </g>
                    </svg>
                  </Tooltip>
                </InputLabel>
              </div>
              <div className="kyc-checkbox-grid__check-box" style={{ marginTop: 0, marginBottom: 0 }}>
                <div>
                  {usesGridElectricity !== "true" && (
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      onClick={() => {
                        setUsesGridElectricity("true");
                        handleFacilityChange('usesGridElectricity', true);
                      }}
                    >
                      <rect
                        x="1"
                        y="1"
                        width="16"
                        height="16"
                        rx="4"
                        stroke="url(#paint0_linear_2889_18043)"
                        strokeWidth="1.33333"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_2889_18043"
                          x1="1"
                          y1="1.36719"
                          x2="20.0689"
                          y2="10.7886"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#006633" />
                          <stop offset="1" stopColor="#02A4CC" />
                        </linearGradient>
                      </defs>
                    </svg>
                  )}
                  {usesGridElectricity === "true" && (
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      onClick={() => {
                        setUsesGridElectricity("");
                        handleFacilityChange('usesGridElectricity', null);
                      }}
                    >
                      <rect
                        x="1"
                        y="1"
                        width="16"
                        height="16"
                        rx="4"
                        stroke="url(#paint0_linear_2889_18037)"
                        strokeWidth="1.33333"
                      />
                      <path
                        d="M5.5 9.49992L7.83333 11.8333L12.5 6.83325"
                        stroke="url(#paint1_linear_2889_18037)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_2889_18037"
                          x1="1"
                          y1="1.36719"
                          x2="20.0689"
                          y2="10.7886"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#006633" />
                          <stop offset="1" stopColor="#02A4CC" />
                        </linearGradient>
                        <linearGradient
                          id="paint1_linear_2889_18037"
                          x1="5.5"
                          y1="6.948"
                          x2="12.5203"
                          y2="11.8039"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#006633" />
                          <stop offset="1" stopColor="#02A4CC" />
                        </linearGradient>
                      </defs>
                    </svg>
                  )}
                  Yes
                </div>
                <div>
                  {usesGridElectricity !== "false" && (
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      onClick={() => {
                        setUsesGridElectricity("false");
                        handleFacilityChange('usesGridElectricity', false);
                      }}
                    >
                      <rect
                        x="1"
                        y="1"
                        width="16"
                        height="16"
                        rx="4"
                        stroke="url(#paint0_linear_2889_18043)"
                        strokeWidth="1.33333"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_2889_18043"
                          x1="1"
                          y1="1.36719"
                          x2="20.0689"
                          y2="10.7886"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#006633" />
                          <stop offset="1" stopColor="#02A4CC" />
                        </linearGradient>
                      </defs>
                    </svg>
                  )}
                  {usesGridElectricity === "false" && (
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      onClick={() => {
                        setUsesGridElectricity("");
                        handleFacilityChange('usesGridElectricity', null);
                      }}
                    >
                      <rect
                        x="1"
                        y="1"
                        width="16"
                        height="16"
                        rx="4"
                        stroke="url(#paint0_linear_2889_18037)"
                        strokeWidth="1.33333"
                      />
                      <path
                        d="M5.5 9.49992L7.83333 11.8333L12.5 6.83325"
                        stroke="url(#paint1_linear_2889_18037)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_2889_18037"
                          x1="1"
                          y1="1.36719"
                          x2="20.0689"
                          y2="10.7886"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#006633" />
                          <stop offset="1" stopColor="#02A4CC" />
                        </linearGradient>
                        <linearGradient
                          id="paint1_linear_2889_18037"
                          x1="5.5"
                          y1="6.948"
                          x2="12.5203"
                          y2="11.8039"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#006633" />
                          <stop offset="1" stopColor="#02A4CC" />
                        </linearGradient>
                      </defs>
                    </svg>
                  )}
                  No
                </div>
              </div>
            </div>


            <button className="kyc_submit" type="submit">Complete</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default KYCGovernanceMonitoringForm;